/** Nome exibido do produto — trocável por instalação (ADR 0022) sem mudar código. */
export const NOME_PRODUTO: string =
  (import.meta.env['VITE_NOME_PRODUTO'] as string | undefined) ?? 'FiscoAI';
